// components
import Provider from '@/pages/Profile/components/LLMKeys/components/Provider';
// utils
import { useProvidersQuery } from '@/services/customer/providers/providers.queries.ts';

const LLMKeys = () => {
    const { data: providers = [] } = useProvidersQuery();
    return (
        <div className="flex flex-col gap-4">
            {providers.map((provider) => (
                <Provider key={provider.id} provider={provider} />
            ))}
        </div>
    );
};

export default LLMKeys;
